import { DateTime } from 'luxon';

const formatTime = timestamp => {
  const date = DateTime.fromMillis(timestamp);
  return date.toLocaleString({
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
};

export default formatTime;



// WEBPACK FOOTER //
// ./src/lib/helpers/GeneralHelpers/formatTime.js